import React, { Component } from 'react';
import styled from 'styled-components';
import Button from '@material-ui/core/Button';
import { connect } from 'react-redux';

import { getStripeTrainerLogin } from '../../../services/apiServices';

const Container = styled.div`
  ${'' /* padding: 10px; */}
`;

class StripeAccount extends Component {
  handleClick = async event => {
    const response = await getStripeTrainerLogin();
    window.location = response.stripe_login;
  }

  render() {
    const { verified } = this.props.settingsState;
    let button, message;

    if (verified) {
      button = (
        <Button variant="contained" color="primary" onClick={this.handleClick}>
          Update Your Payment Account
        </Button>
      );
      message = (
        <p>Your Stripe account is connected. Use the button below if you need to update your account.</p>
      );
    }
    else {
      button = (
        <Button variant="contained" color="primary" onClick={this.handleClick}>
          Set Up Your Payment Account
        </Button>
      );
      message = (
        <p>Payment is securely integrated with <a href="https://stripe.com/" target="_blank" rel="noreferrer">Stripe</a>. Create an account to start getting paid.</p>
      );
    }

    return (
      <Container>
        {message}
        {button}
      </Container>
    );
  }
}

function mapStateToProps(state) {
  return {
    settingsState: state.settingsState
  };
}

export default connect(mapStateToProps)(StripeAccount);
